<script>
    import { onMount } from "svelte";
    import { sortArray, toGroups, emptyAllQuestions } from "../scripts/utils";
    import { push } from "svelte-spa-router";
    import { testAnswers } from "../scripts/answers";
    import { questions, lang } from "../scripts/stores";
    import Modal from "../components/Modal.svelte";
    import Chart from "../components/Chart.svelte";
    import CategoryInfo from "../components/CategoryInfo.svelte";

    let openModal = false;
    let totalPercents = [];
    let highScores = [[], [], [], []];
    let maxAnswers = 5;
    let hideAllInfos = false;

    const treshold = 5;
    const totalPoints = [[], [], [], []];

    $: if($lang) {
        calculateResults();
    }
    else {
        calculateResults();
    }

    function calculateResults() {

        totalPercents = [];
        highScores = [[], [], [], []];

        const sortedQuestions = toGroups(sortArray($questions));

        for(let i = 0; i < sortedQuestions.length; i++) {
            
            let group = sortedQuestions[i];
            let max;

            if(maxAnswers > group.length) max = group.length;
            else max = maxAnswers;

            for(let j = 0; j < max; j++) {
                if(group[j].value >= treshold && !group[j].skip) highScores[i].push(group[j]);
            } 
        }
        
        for(let i = 0; i < $questions.length; i++) {
            let { group, value, type, skip } = $questions[i];

            if(type === 0 && value >= treshold && !skip) totalPoints[group - 1].push(value);
        }

        for(let i = 0; i < totalPoints.length; i++) {
            let points = totalPoints[i];
            let sum = 0;

            for(let j = 0; j < points.length; j++) {
                sum += points[j];
            }
            let totalPercent = Math.floor(sum / points.length);

            totalPercents[i] = isNaN(totalPercent) ? 0 : totalPercent;
        }

        totalPercents = totalPercents;
        highScores = highScores;
    }

    function saveAnswers(fileName, method) {
        const json = JSON.stringify($questions);

        if(method === "file") download(json, fileName);
        else if(method === "localStorage") localStorage.setItem(fileName, json);
    }

    function download(content, fileName) {
        const a = document.createElement("a");
        const file = new Blob([content], { type: "application/json"});
        a.href = URL.createObjectURL(file);
        a.download = fileName;
        a.click();
    }

    function scrollToElement(index) {
        const elem = document.querySelector(`[data-category="${index}"]`);
        elem.scrollIntoView({ behavior: "smooth" });
    }

    function toStart() {
        $questions = $questions = emptyAllQuestions($questions);
        group = 1;
        page = 1;
        push(`/form/${group}/${page}`);
    }

    // onMount(() => {
    //     calculateResults();
    // });
</script>

<style>
    h2 { text-align: center; }
    .selections {
        display: flex;
        justify-content: flex-end;
    }
    .hide-btn {
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
    }
    .hide-btn .material-icons { 
        line-height: unset; 
        margin-right: .5rem;
    }
    button .material-icons {
        margin-right: .5rem;
    }
    .categories {
        max-width: 960px;
        margin-top: 3rem;
        margin-right: auto;
        margin-left: auto;
    }
    .feedback-btn {
        position: fixed;
        bottom: .7rem;
        right: .7rem;
    }
</style>

{#if totalPercents.length > 0}
    <Chart totalScores={ totalPercents } on:select={ e => scrollToElement(e.detail.index) } />
{/if}

<div class="categories">
    <h2>{ $lang === "fi" ? "Tulokset kategorioittain" : "Results by category" }</h2>

    <div class="selections">
        <button class="hide-btn" on:click={ () => hideAllInfos = !hideAllInfos }>
            {#if hideAllInfos}
     
            <i class="material-icons">
                    unfold_more
                </i>
                { $lang == "fi" ? "Laajenna kaikki" : "Show all" }
            {:else}
                <i class="material-icons">
                    unfold_less
                </i>
                { $lang == "fi" ? "Pienennä kaikki" : "Hide all" }
            {/if}
        </button>
    </div>

    {#each highScores as scores, i}
        <CategoryInfo index={ i } scores={ scores } show={ !hideAllInfos } />
    {/each}

</div>

<div class="buttons evenly">
    <button class="btn btn-outline btn-primary" on:click={ toStart }>
        <i class="material-icons">redo</i>
        { $lang === "fi" ? "Tee uudestaan" : "Do again" }

    </button>
    <button class="btn btn-primary" on:click={ () => openModal = true }>
        <i class="material-icons">save</i>
        { $lang === "fi" ? "Tallenna" : "Save" }

    </button>
</div>

<a class="btn btn-success feedback-btn" type="button" href="https://elomake.samk.fi/lomakkeet/12540/lomake.html" target="_blank">
    <i class="material-icons" style="margin-right: 0.5rem;">feedback</i>
    { $lang === "fi" ? "Anna palautetta" : "Give feedback" }
</a>

<Modal bind:open={ openModal } onClick={ saveAnswers } />